export default __webpack_public_path__ + "static/media/france.c01e1040.svg";